import angular from "angular";

let MatchesFactory = angular
  .module("MatchesFactory", [])
  .factory("MatchesFactory", ($rootScope, HttpFactory, URLS) => {
    "ngInject";
    const MATCH_STATES = {
      MATCH_STATE_ROUND_ONE: 1,
      MATCH_STATE_ROUND_TWO: 2,
      MATCH_STATE_END: 3,
    };
    const MATCH_TYPES = {
      INDOOR: "indoor",
      OUTDOOR: "outdoor",
    };
    const MATCH_MOVE_TARGETS_DIRECTION = {
      FRONT: "front",
      BACK: "back",
    };
    const MATCH_PRINTS = {
      LEAGUES_LIST: "leaguesList",
      PLAYERS_LIST: "playersList",
      TARGETS_LIST: "targetsList",
      TEAMS_LIST: "teamsList",
      QUALIFICATION: "qualification",
      QR: "qr",
      MEDALS: "medals",
      ELIMINATION_ROUNDS: "medals",
      TARGETS_BOARDS: "targetsBoards",
      EXCEL: "excel",
      EXCEL_IMPORT: "addShotsFromExcel",
      TEAM_ENTRIES_LIST: "teamsEntriesList",
      ATHLETES_SCORECARDS: "scorecards",
      ATHLETES_MATCH_CARDS: "athleteMatchCards",
      CERTIFICATES: "certs",
      ATHLETE_MATCH_ENTRY_CARDS: "athleteMatchEntryCards",
    };
    const MATCH_ELIMINATION_TYPES = {
      INDIVIDUAL: 1,
      TEAM: 2,
      MIXED_TEAM: 3,
    };
    return {
      MATCH_STATES: MATCH_STATES,
      MATCH_TYPES: MATCH_TYPES,
      MATCH_MOVE_TARGETS_DIRECTION: MATCH_MOVE_TARGETS_DIRECTION,
      MATCH_PRINTS: MATCH_PRINTS,
      MATCH_ELIMINATION_TYPES: MATCH_ELIMINATION_TYPES,
      getAll: (params) => {
        let url = URLS.MATCHES;
        let parameters = Object.assign({ page_size: 2000 }, params);
        return HttpFactory.get(url, parameters);
      },
      getOne: (matchId, params, silent = false) => {
        let url = URLS.MATCHES + "/" + matchId;
        let parameters = Object.assign({}, params);
        return HttpFactory.get(url, parameters, silent);
      },
      add: (data) => {
        let url = URLS.MATCHES;
        return HttpFactory.post(url, data);
      },
      update: (matchId, data) => {
        let url = URLS.MATCHES + "/" + matchId;
        return HttpFactory.put(url, data);
      },
      delete: (matchId) => {
        let url = URLS.MATCHES + "/" + matchId;
        return HttpFactory.delete(url);
      },
      /* SCORING */
      addShots: (roundId, data) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ADD_SHOTS, {
          roundId: roundId,
        });

        /* data =>
			for shotNumber from 1 - 12
			shots => [
				'shotNumber' => [
					1: VALUE,
					2: VALUE,
					3: VALUE,
				]
			]
			*/
        return HttpFactory.post(url, data);
      },
      addShotsFromExcel: (matchId, data) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ADD_SHOTS_FROM_EXCEL, {
          matchId: matchId,
        });

        return HttpFactory.get(url, data);
      },
      clear: (roundId) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_CLEAR_SHOTS, {
          roundId: roundId,
        });
        return HttpFactory.post(url);
      },
      finalize: (matchId, state) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_FINALIZE, {
          matchId: matchId,
          state: state,
        });

        return HttpFactory.post(url);
      },
      /* LEAGUES */
      addLeague: (matchId, leagueId) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ADD_LEAGUE, {
          matchId: matchId,
        });

        /* data => league_id */
        return HttpFactory.post(url, { league_id: leagueId });
      },
      removeLeague: (matchId, leagueId) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_REMOVE_LEAGUE, {
          matchId: matchId,
        });

        /* data => league_id */
        return HttpFactory.post(url, { league_id: leagueId });
      },
      moveLeagues: (matchId, newMatchId, leagueIds) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_MOVE_LEAGUES, {
          matchId: matchId,
        });

        /* data =>
			new_match_id
			matchLeagues = [] | league ids to move
			*/
        return HttpFactory.post(url, {
          new_match_id: newMatchId,
          matchLeagues: leagueIds,
        });
      },
      /* PLAYERS */
      addPlayer: (matchId, playerId, leagueId, teamId, data) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ADD_PLAYER, {
          matchId: matchId,
          playerId: playerId,
          leagueId: leagueId,
          teamId: teamId,
        });
        return HttpFactory.post(url, data);
      },
      removePlayer: (matchId, playerId) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_REMOVE_PLAYER, {
          matchId: matchId,
          playerId: playerId,
        });

        return HttpFactory.delete(url);
      },
      checkInPlayer: (matchId, playerId) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_CHECK_IN_PLAYER, {
          matchId: matchId,
          playerId: playerId,
        });

        return HttpFactory.put(url);
      },
      updatePlayerLeague: (matchId, playerId, leagueId, data) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_UPDATE_PLAYER_LEAGUE, {
          matchId: matchId,
          playerId: playerId,
          leagueId: leagueId,
        });

        return HttpFactory.put(url, data);
      },
      updateTeamInformation: (matchId, teamId, data) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_UPDATE_TEAM_INFO, {
          matchId: matchId,
          teamId: teamId,
        });

        return HttpFactory.put(url, data);
      },
      /* TARGETS */
      produceTargets: (matchId, perTarget) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_PRODUCE_TARGETS, {
          matchId: matchId,
        });

        /* data => perTarget | int [2,3,4] */
        return HttpFactory.post(url, { perTarget: perTarget });
      },
      clearTargets: (matchId) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_CLEAR_TARGETS, {
          matchId: matchId,
        });

        return HttpFactory.post(url);
      },
      movePlayerToTarget: (matchId, playerId, targetName) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_MOVE_PLAYER_TO_TARGET, {
          matchId: matchId,
          playerId: playerId,
        });

        /* data => target_name | string */
        return HttpFactory.post(url, { target_name: targetName });
      },
      swapTargets: (matchId, targetNameOne, targetNameTwo) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_SWAP_TARGETS, {
          matchId: matchId,
        });

        /* data =>
			target_name_one | string
			target_name_two | string
			*/
        return HttpFactory.post(url, {
          target_name_one: targetNameOne,
          target_name_two: targetNameTwo,
        });
      },
      moveTargets: (matchId, distance, fromTarget, toTarget, direction) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_MOVE_TARGETS, {
          matchId: matchId,
        });

        /* data =>
			distance | int
			fromTarget | int
			toTarget | int
			direction | MATCH_MOVE_TARGETS_DIRECTION
			*/
        return HttpFactory.post(url, {
          distance: distance,
          fromTarget: fromTarget,
          toTarget: toTarget,
          direction: direction,
        });
      },
      /* PRINTS */
      prints: (matchId, print) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_PRINTS, {
          matchId: matchId,
          print: print,
        });

        return HttpFactory.getPDF(url);
      },
      printsEntries: (matchId, teamId) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_PRINTS_ENTRIES, {
          matchId: matchId,
          teamId: teamId,
        });

        return HttpFactory.getPDF(url);
      },
      printsElimination: (matchId, leagueId, eliminationType) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_PRINTS_ELIMINATION, {
          matchId: matchId,
          leagueId: leagueId,
          eliminationType: eliminationType,
        });

        return HttpFactory.getPDF(url);
      },
      printsEliminationTargetBoards: (
        matchId,
        leagueId,
        eliminationType,
        round
      ) => {
        let url = HttpFactory.buildUrl(
          URLS.MATCHES_PRINTS_ELIMINATION_TARGET_BOARDS,
          {
            matchId: matchId,
            leagueId: leagueId,
            eliminationType: eliminationType,
            round,
          }
        );

        return HttpFactory.getPDF(url);
      },
      eliminationProduceTargets: (
        matchId,
        leagueId,
        eliminationType,
        round,
        perTarget,
        startFrom
      ) => {
        let url = HttpFactory.buildUrl(
          URLS.MATCHES_PRINTS_ELIMINATION_PRODUCE_TARGETS,
          {
            matchId: matchId,
            leagueId: leagueId,
            eliminationType: eliminationType,
            round,
          }
        );

        return HttpFactory.post(url, { perTarget, startFrom });
      },
      /* ELIMINATIONS */
      createElimination: (matchId, leagueId, participants, eliminationType) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION, {
          matchId: matchId,
          leagueId: leagueId,
          eliminationType: eliminationType,
        });

        /* data =>
			participants
			*/
        return HttpFactory.post(url, { participants: participants });
      },
      details: (matchId, leagueId, eliminationType) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION, {
          matchId: matchId,
          leagueId: leagueId,
          eliminationType: eliminationType,
        });

        return HttpFactory.get(url);
      },
      nextRoundElimination: (matchId, leagueId, eliminationType) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION_NEXT_ROUND, {
          matchId: matchId,
          leagueId: leagueId,
          eliminationType: eliminationType,
        });

        return HttpFactory.post(url);
      },
      deleteElimination: (matchId, leagueId, eliminationType) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION, {
          matchId: matchId,
          leagueId: leagueId,
          eliminationType: eliminationType,
        });

        return HttpFactory.delete(url);
      },
      updateElimination: (
        matchId,
        leagueId,
        teamId,
        eliminationType,
        players
      ) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION_UPDATE, {
          matchId: matchId,
          leagueId: leagueId,
          teamId: teamId,
          eliminationType: eliminationType,
        });

        /* data => players | array of size 2-3 */
        return HttpFactory.put(url, { players: players });
      },
      addShotsElimination: (matchOlympicId, eliminationType, data) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION_ADD_SHOTS, {
          matchOlympicId: matchOlympicId,
          eliminationType: eliminationType,
        });

        /* data =>
			for round where Key is roundId =>
				for shotNumber from 1 - 12
					shots => [
						'shotNumber' => [
							1: VALUE,
							2: VALUE,
							3: VALUE,
						]
					]
			*/
        return HttpFactory.post(url, data);
      },
      clearShotsElimination: (matchOlympicId, eliminationType) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION_CLEAR_SHOTS, {
          matchOlympicId: matchOlympicId,
          eliminationType: eliminationType,
        });

        return HttpFactory.post(url);
      },
      forfeitElimination: (matchOlympicId, eliminationType, playerId) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION_FORFEIT, {
          matchOlympicId: matchOlympicId,
          playerId: playerId,
          eliminationType: eliminationType,
        });

        return HttpFactory.post(url);
      },
      results: (matchId, params) => {
        let url = HttpFactory.buildUrl(URLS.MATCHES_RESULTS, {
          matchId: matchId,
        });
        let parameters = Object.assign({}, params);
        return HttpFactory.get(url, parameters);
      },
    };
  }).name;

export default MatchesFactory;



// WEBPACK FOOTER //
// ./client/app/services/matches.factory.js